/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { ExpensePaymentFields } from '../../expenses/components/ExpensePaymentFields';
import type { ExpenseSettleMethod } from '../../expenses/components/expenseSettlementMethods';
import type {
  ActiveCashSessionInfo,
  ExpenseAlreadyPaidKind,
  ExpensePaidFormChoice,
} from '../../expenses/components/expensePaymentFlow';

type Props = {
  expenseDate: string;
  paidForm: ExpensePaidFormChoice | null;
  onPaidFormChange: (value: ExpensePaidFormChoice | null) => void;
  alreadyPaidKind: ExpenseAlreadyPaidKind | null;
  onAlreadyPaidKindChange: (value: ExpenseAlreadyPaidKind | null) => void;
  nonDrawerMethod: ExpenseSettleMethod;
  onNonDrawerMethodChange: (value: ExpenseSettleMethod) => void;
  settleNote: string;
  onSettleNoteChange: (value: string) => void;
  paidDate: string;
  onPaidDateChange: (value: string) => void;
  activeCashSession: ActiveCashSessionInfo | null;
  pastCashDrawerConfirmed: boolean;
  onPastCashDrawerConfirmedChange: (value: boolean) => void;
  submitting?: boolean;
  onOpenCash?: () => void;
  testIDPrefix?: string;
};

export function PurchaseReceptionPaymentBlock({
  expenseDate,
  paidForm,
  onPaidFormChange,
  alreadyPaidKind,
  onAlreadyPaidKindChange,
  nonDrawerMethod,
  onNonDrawerMethodChange,
  settleNote,
  onSettleNoteChange,
  paidDate,
  onPaidDateChange,
  activeCashSession,
  pastCashDrawerConfirmed,
  onPastCashDrawerConfirmedChange,
  submitting = false,
  onOpenCash,
  testIDPrefix = 'purchases.reception.payment',
}: Props) {
  return (
    <ExpensePaymentFields
      expenseDate={expenseDate}
      paymentStatus="paid"
      hidePaymentStatus
      onPaymentStatusChange={() => {}}
      paidForm={paidForm}
      onPaidFormChange={onPaidFormChange}
      alreadyPaidKind={alreadyPaidKind}
      onAlreadyPaidKindChange={onAlreadyPaidKindChange}
      nonDrawerMethod={nonDrawerMethod}
      onNonDrawerMethodChange={onNonDrawerMethodChange}
      settleNote={settleNote}
      onSettleNoteChange={onSettleNoteChange}
      paidDate={paidDate}
      onPaidDateChange={onPaidDateChange}
      activeCashSession={activeCashSession}
      pastCashDrawerConfirmed={pastCashDrawerConfirmed}
      onPastCashDrawerConfirmedChange={onPastCashDrawerConfirmedChange}
      submitting={submitting}
      onOpenCash={onOpenCash}
      testIDPrefix={testIDPrefix}
    />
  );
}

export function defaultReceptionPaidForm(activeCashSessionId: string | null): ExpensePaidFormChoice {
  return activeCashSessionId ? 'cash_drawer_now' : 'transfer';
}
